import React from 'react'

export interface ProgressBarProps {
  value: number // 0-100
  className?: string
  color?: 'green' | 'blue' | 'sun'
}

const trackBase = 'w-full h-3 rounded-full bg-off-black/40'
const fillByColor = {
  green: 'bg-status-green',
  blue: 'bg-status-blue',
  sun: 'bg-sun'
} as const

const ProgressBar: React.FC<ProgressBarProps> = ({ value, className = '', color = 'green' }) => {
  const clamped = Math.max(0, Math.min(100, value))

  return (
    <div
      className={`${trackBase} ${className}`}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={clamped}
    >
      <div className={`h-3 ${fillByColor[color]} rounded-full`} style={{ width: `${clamped}%` }} />
    </div>
  )
}

export default ProgressBar
